import React, { createContext } from 'react';
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var RouterLinkProviderContext = /*#__PURE__*/createContext({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */
var RouterLinkProvider = function RouterLinkProvider(_ref) {
  var routerLinkComponent = _ref.routerLinkComponent,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(RouterLinkProviderContext.Provider, {
    value: {
      routerLinkComponent: routerLinkComponent
    }
  }, children);
};
export default RouterLinkProvider;